import { useEffect } from 'react'
import { trackReturnVisit } from '@/lib/analytics'

const STORAGE_KEY = 'fuguelab_visit_count'

/**
 * Tracks return visits via localStorage counter.
 * Fires a return_visit GA4 event on visit 2+.
 */
export function useReturnVisitTracker() {
  useEffect(() => {
    try {
      const count = parseInt(localStorage.getItem(STORAGE_KEY) ?? '0', 10) + 1
      localStorage.setItem(STORAGE_KEY, String(count))
      if (count > 1) {
        trackReturnVisit(count)
      }
    } catch {
      // localStorage unavailable (private browsing, etc.)
    }
  }, [])
}
